import {enumerate} from 'ts-transformer-enumerate';
import {keys} from 'ts-transformer-keys';

import {
    DataDescriptor,
    dataDescriptorSchema
} from '~/shared/src/utilities/dataStructure';
import {FilterMatchMode} from '~/shared/src/validationSchemes/modules/overview';
import Joi from '~/shared/src/utilities/joiExtended';

export type ConditionOperator = FilterMatchMode | 'and' | 'or';
export const conditionOperator = enumerate<ConditionOperator>();

export type DataDescriptorValues = {
    [ dataDescriptorAlias : string ] : any;
};

export type Condition = {
    id? : number;
    leftExpression? : string | Condition[];
    leftExpressionDataDescriptor? : DataDescriptor;

    operator? : ConditionOperator;

    rightExpression? : string | Condition[];
    rightExpressionDataDescriptor? : DataDescriptor;
};
export const conditionProps = keys<Condition>();


/*** validation schemes **********************************************************************************************/

export const conditionSchema = Joi.object( {
    id                           : Joi.number(),
    leftExpressionDataDescriptor : dataDescriptorSchema,
    leftExpression               : Joi.alternatives()
        .try(
            Joi.string(),
            Joi.array()
                .items( Joi.link( '#conditionSchema' ) )
        ),
    operator                     : Joi.string()
        .valid( ...conditionOperator ),
    rightExpressionDataDescriptor: dataDescriptorSchema,
    rightExpression              : Joi.alternatives()
        .try(
            Joi.string(),
            Joi.array()
                .items( Joi.link( '#conditionSchema' ) )
        )
} ).id( 'conditionSchema' );
